// @ts-nocheck
/* eslint-disable */
export const llaPlatformBoltIcon = {
    data: `<svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.75 9.25H0.75L7.25 0.75V6.75H11.25L4.75 15.25V9.25Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'bolt' as const
};